import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type ProductInquiryItem = OAISchema['MarketPlaceProductInquiryResponse'];
type CursorPagedResponse = OAISchema['CursorPagedResponse'];

// 페이지네이션 응답 타입 (content를 구체화)
export type ProductInquiryPageResponse = Omit<
  CursorPagedResponse,
  'content'
> & {
  content: ProductInquiryItem[];
};

// Request 타입
export type ProductInquiryRequest =
  OAISchema['MarketPlaceProductInquiryRequest'];

export interface InquiryDataSource {
  // Query
  getMyInquiries(params?: {
    lastInquiryId?: number;
    size?: number;
  }): Promise<ProductInquiryPageResponse>;
  getMyInquiryCount(): Promise<number>;

  // Mutation
  editInquiry(
    inquiryId: number,
    data: ProductInquiryRequest,
  ): Promise<ProductInquiryItem>;
  deleteInquiry(inquiryId: number): Promise<ProductInquiryItem>;
}

export class InquiryDataSourceImpl implements InquiryDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getMyInquiries(params?: { lastInquiryId?: number; size?: number }) {
    return this.client.request<ProductInquiryPageResponse>({
      url: '/api/market-place/v1/product-inquiries',
      method: 'get',
      params,
    });
  }

  async getMyInquiryCount() {
    return this.client.request<number>({
      url: '/api/market-place/v1/product-inquiries/count',
      method: 'get',
    });
  }

  async editInquiry(inquiryId: number, data: ProductInquiryRequest) {
    return this.client.request<ProductInquiryItem>({
      url: `/api/market-place/v1/product-inquiries/${inquiryId}`,
      method: 'put',
      data,
    });
  }

  async deleteInquiry(inquiryId: number) {
    return this.client.request<ProductInquiryItem>({
      url: `/api/market-place/v1/product-inquiries/${inquiryId}`,
      method: 'delete',
    });
  }
}

export const inquiryDataSource = new InquiryDataSourceImpl();
